<template>
  <header class="flex flex-wrap justify-between items-center px-2 bg-white border-b border-section_border">
    <p class="flex-grow">
      <router-link :to="toPlan">
        <img src="@/assets/images/logo-service.png" alt="HAWAII MaaS" class="header-logo" width="136" height="34" />
      </router-link>
    </p>
    <template v-if="$route.name == 'map'">
      <router-link :to="toPlan" class="flex justify-center items-center mr-2 px-2 rounded bg-link text-white link-header">
        <img src="@/assets/images/icon-header-plan.svg" alt="map" class="h-3 pr-1" />
        <span class="block whitespace-no-wrap text-xs flex-shrink-0">{{ $t('plan_label') }}</span>
      </router-link>
    </template>
    <template v-if="$route.name !== 'map'">
      <router-link :to="toMap" class="flex justify-center items-center mr-2 px-2 rounded bg-link text-white link-header">
        <img src="@/assets/images/icon-header-map.svg" alt="map" class="h-3 pr-1" />
        <span class="block whitespace-no-wrap text-xs flex-shrink-0">{{ $t('map_label') }}</span>
      </router-link>
    </template>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheHeader',
  computed: {
    ...mapGetters({
      from: 'map/getFrom',
      lang: 'user/getLang'
    }),
    toPlan: function () {
      if (this.from.name) {
        if (this.from.name == 'root') {
          return {
            name: 'plans'
          }
        } else if (this.from.name == 'top') {
          return {
            name: 'top',
            params: { lang: this.lang }
          }
        } else {
          return {
            name: this.from.name,
            params: this.from.params
          }
        }
      } else {
        // NOTE: /mapに直接きた場合
        if (this.lang && this.lang !== 'ja') {
          return {
            name: 'top',
            params: { lang: this.lang}
          }
        } else {
          return {
            name: 'plans'
          }
        }
      }
    },
    toMap: function () {
      return {
        name: 'map',
        params: { lang: this.$store.getters['user/getLang'] }
      }
    }
  }
}
</script>
